export const WALK_STORAGE_EVENT = 'painori-walk-daily-updated';
export const WALK_START_PENDING = 'walk_start_pending';
export const WALK_RETURN_PENDING = 'walk_return_pending';

export const WALK_MISSIONS = [
  { id: 'walk_500', distanceM: 500, rewardSpot: 0.1 },
  { id: 'walk_1500', distanceM: 1500, rewardSpot: 0.3 },
  { id: 'walk_3000', distanceM: 3000, rewardSpot: 0.6 }
];

export const WALK_FILTERS = {
  maxAccuracyM: 50,
  maxSpeedMps: 3,
  minSpeedMps: 0.3,
  maxIntervalSec: 30,
  minSegmentM: 1.5
};
